import { ReactElement, useEffect } from "react";
import { FlowableFlowApp } from "@flowable/work-views";
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import styled from 'styled-components';

import { WORKFLOWS_BASE_URL } from 'config/api.config';
import "@flowable/work-views/dist/index.css";
import PageContainer from "src/containers/page-container";
import CONST from 'utils/constants';

const { WORKFLOWS_STORE_KEYS } = CONST

export const WorkflowsAppViewContainer = styled(PageContainer)`
  height:100%;
`;

// Set endpoints synchronously before component renders to avoid race condition
const initWorkflowsEndpoints = (): void => {
  const isLocalWorflows = process.env.WORKFLOWS_TARGET_ENV === 'local';
  const isDevelopmentMode = process.env.NODE_ENV === 'development';

  if (window.flowable) {
    window.flowable.endpoints = {
      baseUrl: isLocalWorflows
        ? "/"
        : isDevelopmentMode
          ? '/toqio-route'
          : `${WORKFLOWS_BASE_URL}/toqio-route/`
    };
  }
}

// Initialize endpoints at module load time 
// so the initial calls while loading the module use also the correct baseUrl
initWorkflowsEndpoints();

const CommonWorkflowsAppView = ({ appKey }: { appKey: string }): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    ////We need the history for the WFs navigation methods and with react-router-dom v6 doesn't exist,so this is a workaround to generate our own history object so it can be used
    const historyAdapter = {
      push: (path: string, state?: any) => navigate(path, { state }),
      replace: (path: string, state?: any) => navigate(path, { replace: true, state }),
      goBack: () => navigate(-1),
      location: location,
      listen: (_listener: any) => {
        return () => { };
      }
    };

    // Set history before rendering the screen so WF can use custom navigation methods we pass them
    window?.flowable?.externals?.additionalData?.store.set(WORKFLOWS_STORE_KEYS.HISTORY, historyAdapter)
  }, [navigate, location]);

  const routerLocation = useLocation();
  const navType = useNavigationType() as string;

  // Reset navigation to Workflows' app home when landing in a new Workflows app.
  useEffect(() => {
    if (navType === "PUSH") {
      location.hash = "/";
    }
  }, [routerLocation, navType]);

  return (
    <WorkflowsAppViewContainer className="m-t-1">
      <FlowableFlowApp
        key={appKey}
        flowAppId={appKey}
        fullScreen={false}
        hideNavigationElements={true}
        showLogin={true}
      />
    </WorkflowsAppViewContainer>
  );
}

export default CommonWorkflowsAppView;